export default [
  {
    title: "แผนประกันการเดินทางในประเทศ",
    link: require("../../../static/pdf-template/Domestic.pdf"),
    file_name: "ใบสมัครประกันเดินทางภายในประเทศ.pdf"
  }
]